/*
 * @Author: cn1994
 * @Date: 2023-12-19 11:13:44
 * @LastEditors: cn1994
 * @LastEditTime: 2025-03-04 14:01:35
 * @Description: file content
 */
// app3.0 路由
const routes = [
  {
    path: "/apphome",
    meta: {
      title: '版本切换',
      volcengine: true,
    },
    component: () => import("../pages/personalized/apphome.vue"),
  },
  //3.0板块布局
  {
    path: "/applayout",
    component: () => import("../pages/personalized/applayout.vue")
  },
  {
    path: "/appCustom",
    meta: {
      title: '版块布局',
      volcengine: true,
    },
    component: () => import("../pages/personalized/appCustom.vue")
  },
  {
    path: "/appCustomV2",
    meta: {
      title: '版块布局',
      volcengine: true,
    },
    component: () => import("../pages/personalized/appCustomIndex.vue")
  },
  // app个性化内跳转
  {
    path: '/appDecoration/readMaterials',
    name: 'appDecoration/readMaterials',
    meta:{
      title: "模块管理"
    },
    component: () => import('../pages/textbook/read/read.vue'),
  },
  // app个性化内跳转-书籍账号非主服务器专用
  {
    path: '/appDecoration/readMaterials_shuji',
    name: 'appDecoration/readMaterials_shuji',
    meta:{
      title: "模块管理"
    },
    component: () => import('../pages/textbook/shujiRead/read.vue'),
  },
  // 阅读区内跳转
  {
    path: '/readPlate/readMaterials',
    name: 'readPlate/readMaterials',
    meta:{
      title: "模块管理"
    },
    component: () => import('../pages/textbook/read/read.vue'),
  },
  // 制作视频配音课件
  {
    path: '/readPlate/createVideoDubbing',
    name: 'readPlate/createVideoDubbing',
    meta: { title: "制作视频配音" },
    component: () => import('../pages/createVideoDubbing/editBook.vue'),
  },
  {
    path: "/appdesign",
    meta: {
      title: '主题设计',
      volcengine: true,
    },
    component: () => import("../pages/personalized/appdesign.vue")
  },
  
  {
    path: "/startup",
    meta:{
      title: "APP启动页",
      volcengine: true,
    },
    component: () => import("../pages/startup/index.vue"),
  },
  {
    path: "/learning",
    meta:{
      title: "APP轮播图",
      volcengine: true,
    },
    component: () => import("../pages/learning/index.vue"),
  },
  //精选课程
  {
    path: '/learning/readMaterials',
    name: 'readMaterials',
    meta:{
      title: "精选课程"
    },
    component: () => import('../pages/textbook/read/read.vue'),
  },
  
   // 3.0plus自定义板块布局
  {
    path: '/sectionCustom',
    meta: {
      title: '自定义板块布局',
      volcengine: true,
    },
    component: () => import('../pages/custom/section/index.vue')
  },
   // 3.0plus内部账号自定义板块布局
   {
    path: '/inSectionCustom',
    meta: {
      title: '自定义板块布局',
      volcengine: true,
    },
    component: () => import('../pages/custom/inSection/index.vue')
  },
  //新版本机构
  {
    path: '/appDecoration',
    name: 'appDecoration',
    meta: {
      title: 'APP装修',
      volcengine: true,
    },
    component: () => import('../pages/appDecoration/appDecoration.vue')
  },
  //老版本机构
  {
    path: '/appRenovation',
    meta: {
      title: 'APP装修',
      volcengine: true,
    },
    component: () => import('../pages/appDecoration/Renovation.vue')
  },
  // 阅读区教材
  {
    path: '/sectionCustom/readMaterials',
    name: 'readMaterials',
    meta:{
      title: "模块管理"
    },
    component: () => import('../pages/textbook/read/read.vue'),
  },
];
export default routes;